import { Badge, Box, Flex, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formElementSchema } from '../../formBuilder/schemas/formElement.schema';
import { QUESTIONNAIRE_ELEMENT_TYPE } from '../../questionnaireTemplate.enums';

interface QuestionHeaderProps {
  question: string;
  questionNumber: string;
  isKnockOut: boolean;
  type: QUESTIONNAIRE_ELEMENT_TYPE;
}

const QuestionHeader: React.FC<QuestionHeaderProps> = ({ question, questionNumber, isKnockOut, type }) => {
  const { t } = useTranslation('questionnaireTemplate');
  const schema = formElementSchema[type] || /* istanbul ignore next */ formElementSchema[QUESTIONNAIRE_ELEMENT_TYPE.FREE_FORM];
  const fontWeight = isKnockOut ? '700' : '400';

  return (
    <Box flex="1">
      <Flex justify="space-between" align="center" mb={1}>
        <Text
          data-testid="question-number-label"
          fontSize="14px"
          fontWeight={fontWeight}
          whiteSpace="pre-line"
          wordBreak="break-word"
        >
          Question
          {questionNumber}
        </Text>
        <Badge
          data-testid="question-type-badge"
          borderRadius="full"
          fontSize="sm"
          fontWeight="400"
          textTransform="capitalize"
          bg={schema.colors.bg}
          color={schema.colors.text}
          px={3}
          py={1}
        >
          {t(`formBuilder.schema.${schema.chipLabel}`)}
        </Badge>
      </Flex>
      <Text fontSize="14px" fontWeight={fontWeight} wordBreak="break-word">
        {question}
      </Text>
    </Box>
  );
};

export default QuestionHeader;
